<app-toolbar></app-toolbar>
<div class="containerr">
<router-outlet></router-outlet>
</div>
<app-footer id="foter"></app-footer>

<!-- 
    /////////////////////////////////////////////////////////////////////////
    |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||

    ###################### REGISTRO DE TRABAJO ##############################
        -Auditorias
        -barra abajo nota
        -cambio pagina principal
        -cambio login y registro
        -cambio spinner de carga
        -cambio pagina donaciones
        -agrego visitas de la nota

        FALTA:
        -sumar visitas -listo-
        -sumar likes
        -completar texto pestaña donaciones
        -crear cronicas
        -crear ensayos
        -admin para cronica y ensayo

    |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
    /////////////////////////////////////////////////////////////////////////
 -->